export default __webpack_public_path__ + "static/media/jcb.4e43392b.svg";